import { useSelector } from "react-redux";
import { State } from "@App/state";
import { useQuery } from "@apollo/client";
import { GarageReviewsQuery, GET_GARAGE_REVIEWS } from "@App/graphql/queries";

export const useReviews = () => {
  const garage = useSelector((state: State) => state.orders.garage);

  const { loading, data, error } = useQuery<GarageReviewsQuery>(GET_GARAGE_REVIEWS, {
    variables: {
      id: garage && +garage.id,
    },
    skip: !garage,
  });

  return {
    loading: loading,
    reviews: data ? data.garage.reviews.data : null,
    error: error,
  };
};
